










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import UserEditForm from '@/components/settings/user/UserEditForm.vue';

@Component({
  components: {
    Header,
    UserEditForm,
    Footer,
  },
})
export default class MyUser extends Vue {}
